import { styled } from 'styled-components'
import { Block } from 'suomifi-ui-components'

export const StyledPriceListContainer = styled(Block)`
  border: 1px solid ${({ theme }) => theme.colors.depthLight1};
  margin: ${({ theme }) => theme.spacing.s} 0 ${({ theme }) => theme.spacing.xl};

  table tbody tr,
  table tfoot tr,
  table + table thead tr {
    border-top: 1px solid ${({ theme }) => theme.colors.depthLight1};
  }

  table {
    width: 100%;

    tr.odd {
      background-color: ${({ theme }) => theme.colors.whiteBase};
    }

    tr.even {
      background-color: ${({ theme }) => theme.colors.depthLight3};
    }

    th,
    td {
      padding: 8px ${({ theme }) => theme.spacing.s};
      ${({ theme }) => theme.typography.bodyText};
    }

    thead th,
    thead td {
      ${({ theme }) => theme.typography.bodySemiBold};
    }

    thead,
    tbody {
      th:first-child,
      td:first-child {
        width: 70%;
      }

      th:last-child,
      td:last-child {
        padding-left: 0;
        text-align: right;
      }
    }

    tfoot td {
      font-style: italic;
    }
  }
`
